module.exports = __webpack_public_path__ + "static/logo-adidas-63fe8f3c61e1f881095f6f89c07704e3.png";